import Application from '@/client';

const app = new Application();
app.app = app;

app.start();